import React from 'react';
import VerificationStatusView from './VerificationStatusView';
const STATUS_CONFIG = {
    SUCCESS: { state: 'verified', label: 'Verified' },
    PENDING: { state: 'pending', label: 'Verification pending' },
    FAIL: { state: 'rejected', label: 'Rejected' },
    WITHDRAWN: null,
};
const AddressVerificationStatusView = ({ status, ...props }) => {
    if (!status)
        return null;
    const config = STATUS_CONFIG[status];
    if (!config)
        return null;
    return (<VerificationStatusView state={config.state} label={config.label} {...props}/>);
};
export default AddressVerificationStatusView;
